import i18n from '@assets/i18n/config';
import { Flags } from '@constants/flags';
import { useFlag } from '@onevesthq/feature-flags/web';
import {
  buildWorkflowLaunchInput,
  type WorkflowLaunchError,
  type WorkflowLaunchParams,
} from '@utils/buildWorkflowLaunchInput';
import { useToast } from 'hephaestus/web';
import { useCallback, useRef } from 'react';

export type WorkflowLaunchToastError = WorkflowLaunchError | 'createFailed';

export const useWorkflowLaunchError = () => {
  const { enqueueToast } = useToast();
  const enqueueToastRef = useRef(enqueueToast);
  enqueueToastRef.current = enqueueToast;

  return useCallback(
    (error: WorkflowLaunchToastError) =>
      enqueueToastRef.current(
        i18n.t(`workflowCompletions:workflowLaunch.errors.${error}`),
        { variant: 'error' },
      ),
    [],
  );
};

export const useWorkflowLaunchInput = () => {
  const { enabled: withContext } = useFlag(Flags.context_aware_workflows, {
    default: false,
  });
  const reportLaunchError = useWorkflowLaunchError();

  return useCallback(
    (params: Omit<WorkflowLaunchParams, 'withContext'>) => {
      const launch = buildWorkflowLaunchInput({ ...params, withContext });
      if ('error' in launch) reportLaunchError(launch.error);
      return launch;
    },
    [withContext, reportLaunchError],
  );
};
